<script>
import LkButton from './LkButton.vue'


export default {
  name: 'LkCmdLink',
  computed: {
    computedClass () {
      return { }
    },
    innerButton () {
      return false
    },
    innerType () {
      return false
    }
  },
  mixins: [
    LkButton
  ]
}
</script>
